import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { customerTokenInterceptor } from './core/customer/customer-token.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    // D4A — customerTokenInterceptor attaches X-Customer-Token ONLY to
    // /public/customer/* and /public/store/{token}/delivery/* requests.
    provideHttpClient(withInterceptors([customerTokenInterceptor])),
  ],
};
